<template>
  <v-main class="team-edit-main">
    <v-container class="pa-6">
      <v-row class="mb-4">
        <v-col cols="12">
          <div class="d-flex gap-2">
            <v-btn
                @click="save()"
                color="primary"
                variant="elevated"
                class="modern-btn"
                prepend-icon="mdi-content-save"
            >
              Save
            </v-btn>
            <v-btn
                @click="$router.go(-1)"
                variant="outlined"
                class="modern-btn"
                prepend-icon="mdi-arrow-left"
            >
              Cancel
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col cols="12" md="6">
          <v-card class="modern-card" elevation="2">
            <v-card-title class="card-header">
              <v-icon class="me-3" color="primary">mdi-account-group</v-icon>
              Team Information
            </v-card-title>
            <v-card-text class="pa-4">
              <v-text-field
                  v-model="teamConfig.name"
                  label="Team Name"
                  variant="outlined"
                  density="comfortable"
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col cols="12" md="6">
          <v-card class="modern-card" elevation="2">
            <v-card-title class="card-header">
              <v-icon class="me-3" color="success">mdi-account-multiple</v-icon>
              Groups
            </v-card-title>
            <v-card-text class="pa-4">
              <v-text-field
                  v-model="newGroupName"
                  label="New group name"
                  append-icon="mdi-plus"
                  variant="outlined"
                  density="comfortable"
                  class="mb-4"
                  @click:append="addGroup"
                  @keyup.enter="addGroup"
              ></v-text-field>
              <v-list v-if="teamConfig.groups && teamConfig.groups.length > 0" class="group-list">
                <v-list-item
                    v-for="(item, index) in teamConfig.groups"
                    :key="item"
                    class="list-item-modern"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                  <template v-slot:append>
                    <v-btn
                        size="small"
                        color="error"
                        variant="outlined"
                        icon="mdi-delete"
                        @click="removeGroup(index)"
                    ></v-btn>
                  </template>
                </v-list-item>
              </v-list>
              <div v-else class="text-center py-4 text-medium-emphasis">
                <v-icon class="mb-2">mdi-information-outline</v-icon>
                <p class="text-body-2">No groups added yet</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col cols="12" md="6">
          <v-card class="modern-card" elevation="2">
            <v-card-title class="card-header">
              <v-icon class="me-3" color="info">mdi-account-tie</v-icon>
              Coaches
            </v-card-title>
            <v-card-text class="pa-4">
              <v-text-field
                  v-model="newCoach"
                  label="New coach email"
                  append-icon="mdi-plus"
                  type="email"
                  variant="outlined"
                  density="comfortable"
                  class="mb-4"
                  @click:append="addCoach"
                  @keyup.enter="addCoach"
              ></v-text-field>
              <v-list v-if="teamConfig.coaches && teamConfig.coaches.length > 0" class="coach-list">
                <v-list-item
                    v-for="(item, index) in teamConfig.coaches"
                    :key="item"
                    class="list-item-modern"
                >
                  <v-list-item-title>{{ item.email }}</v-list-item-title>
                  <template v-slot:append>
                    <v-btn
                        size="small"
                        color="error"
                        variant="outlined"
                        icon="mdi-delete"
                        @click="removeCoach(index)"
                    ></v-btn>
                  </template>
                </v-list-item>
              </v-list>
              <div v-else class="text-center py-4 text-medium-emphasis">
                <v-icon class="mb-2">mdi-information-outline</v-icon>
                <p class="text-body-2">No coaches added yet, add the email address of other coaches you want to give
                  this team access to</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card class="modern-card" elevation="2">
            <v-card-title class="card-header">
              <v-icon class="me-3" color="indigo">mdi-cog</v-icon>
              Configuration
            </v-card-title>
            <v-card-text class="pa-4">
              <v-text-field
                  type="number"
                  label="Water Break Length (minutes)"
                  v-model="teamConfig.waterBreakLength"
                  variant="outlined"
                  density="comfortable"
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!--    <v-row class="row" no-gutters>-->
      <!--      <v-col cols="12" sm="3">-->
      <!--        <v-card title="Practice Templates" variant="">-->
      <!--          <v-card-text>-->
      <!--            <v-btn @click="newTemplate()"  color="primary">-->
      <!--              New-->
      <!--            </v-btn>-->
      <!--            <ul>-->
      <!--              <li v-for="(template) in templates" :key="template.id">-->
      <!--                <router-link :to="{ name: 'teamedit', params: { id: template.id } }">-->
      <!--                  {{template.name}}-->
      <!--                </router-link>-->
      <!--              </li>-->
      <!--            </ul>-->
      <!--          </v-card-text>-->
      <!--        </v-card>-->
      <!--      </v-col>-->

      <!--    </v-row>-->

    </v-container>
  </v-main>

</template>

<script>

import api from '../api'

function getTeam(id, resultHandler) {

  if (id === "new") {
    resultHandler({
      name: "",
      waterBreakLength: 5,
    }, null);
  } else {
    api.teams.get(id, resultHandler)
  }

}

import {currentUserStore} from "@/stores/currentUserStore";

export default {
  name: 'TeamEdit',
  data() {
    return {
      teamConfig: {},
      templates: [],
      newGroupName: null,
      newCoach: null,
    }
  },
  beforeRouteEnter(to, _from, next) {
    getTeam(to.params.id, (team, err) => {
      next(vm => vm.setData(err, team))
    })
  },
  async beforeRouteUpdate(to, _from) {
    this.post = null
    try {
      this.post = await getTeam(to.params.id)
    } catch (error) {
      this.error = error.toString()
    }
  },
  methods: {
    save() {
      console.log("about to save team")
      api.teams.save(this.teamConfig, () => {
        currentUserStore().refresh(() => {
          this.$router.push("/");
        });

      }, (e) => {
        this.$toast.open({message: 'Unable to save team: ' + e.response.data.message, type: 'error', duration: 5000});
      })

    },
    removeGroup(index) {
      this.teamConfig.groups.splice(index, 1);
    },
    removeCoach(index) {
      this.teamConfig.coaches.splice(index, 1);
    },
    addGroup() {
      if (!this.teamConfig.groups) {
        this.teamConfig.groups = [];
      }

      if (!this.newGroupName) {
        return;
      }

      this.teamConfig.groups.push(this.newGroupName);
      this.newGroupName = null;
    },
    addCoach() {
      if (!this.teamConfig.coaches) {
        this.teamConfig.coaches = [];
      }

      if (!this.newCoach) {
        return;
      }

      this.teamConfig.coaches.push({"email": this.newCoach});
      this.newCoach = null;
    },
    setData(error, post) {
      if (error) {
        this.error = error
      } else {
        this.teamConfig = post
      }
    },
    newTemplate() {
      api.templates.new(this.teamConfig.id, (template) => {
        this.$router.push({name: 'templateedit', params: {teamid: this.teamConfig.id, templateid: template.id}})
      }, (e) => {
        this.$toast.open({
          message: 'Unable to create new template: ' + e.response.data.message,
          type: 'error',
          duration: 5000
        });
      })

    },
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Main container styling */
.team-edit-main {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;
}

/* Modern card styling */
.modern-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.modern-card:hover {
  transform: none;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.card-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  font-weight: 600;
  padding: 20px 24px;
}

/* Button styling */
.modern-btn {
  border-radius: 0px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0.5px !important;
}

/* All buttons in this component */
.v-btn {
  border-radius: 0px !important;
}

/* List styling */
.group-list,
.coach-list {
  background: transparent;
}

.list-item-modern {
  border-radius: 12px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.list-item-modern:hover {
  background-color: rgba(0, 0, 0, 0.04);
  transform: none;
}

/* Text field styling */
.v-text-field .v-field {
  border-radius: 12px !important;
}

/* Progress bar styling */
.v-progress-linear {
  border-radius: 2px !important;
}

/* Chip styling */
.v-chip {
  border-radius: 8px !important;
  font-weight: 500 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .modern-card {
    margin-bottom: 16px;
  }

  .card-header {
    padding: 16px 20px;
  }
}

/* Animation for list items */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.list-item-modern {
  animation: slideIn 0.3s ease-out;
}

/* Custom scrollbar for lists */
.v-list {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.v-list::-webkit-scrollbar {
  width: 6px;
}

.v-list::-webkit-scrollbar-track {
  background: transparent;
}

.v-list::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.v-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>